import { useState } from "react"
import MainPageDialog from "../../components/mainPageDialog";
import { Icon } from "../../utils/icons";
import defaultAttachment from "../../assests/images/default_attachment.png";

export const MsgAttachment = ({attachment, remove, className}) => {
    const [previewData, setPreviewData] = useState(null);

    return (
        <>
            <div className={`${remove ? "p-2 border border-slate-200" : ""} relative`}>
                <div className={`${attachment?.type === 'video' ? "w-[200px]" : (attachment?.type === 'audio' ? "" : "w-[80px]")}`}>
                    {attachment?.type === 'image' || attachment.fileType === 'image' ? 
                    <div className="clickable-image cursor-pointer">
                        <img src={attachment?.thumb || defaultAttachment}
                        onError={(e) => { e.target.onerror = null; e.target.src = defaultAttachment; }}
                        alt="attachment_image"
                        onClick={() => setPreviewData(attachment)} />
                    </div> : ''}
                    
                    {attachment?.type === 'audio' ? <span>
                        <div className="audioplayer-wrapper">
                            <audio src={attachment?.url} width="100%" controls ></audio>
                        </div>
                    </span> : ''}
                    
                    {attachment?.type === 'video' ? <span>
                        <div className="audioplayer-wrapper">
                        <video src={attachment?.url} className="w-full max-w-full" controls ></video>
                        </div>
                    </span> : ''}       
                    
                    {(attachment.type !== 'image' && attachment.fileType !== 'image' && 
                        attachment.type !== 'video' && 
                        attachment.type !== 'audio') ? <span className="clickable-image" >
                        <a href="javascript:;" title="View Document" onClick={() => setPreviewData(attachment)}>
                            <Icon type="pdf" size="6" className="h-full w-full text-slate-400" />
                        </a>
                    </span> : ''}
                    
                    {remove ? <a href="javascript:;" className="absolute top-[-14px] right-[-8px]" title="remove" onClick={remove}>
                        <Icon type="cross" className="ml-1 text-red-500" size="5" />
                    </a> : ''}
                </div>
            </div>

            {/* dialogs */}
            {previewData && <MainPageDialog
              title="Preview"
              modalSize="md"
              footerList={[{type: 'close', title: 'Close', action: () => setPreviewData(null)}]}
              onCancelHandler={() => setPreviewData(null)}
            >
                <ImageFrame attachment={previewData} />
            </MainPageDialog>}
        </>
    )
}

const ImageFrame = ({attachment}) => {
    return (
        <>
            {attachment?.type=="image" ?<img src={attachment.url}/>:
                <div className="h-[60vh]">
                    {attachment?.url || attachment?.url == '' ? 
                    <iframe name="documentViewIframe" 
                    width="100%" 
                    className="doc-viewer-frame h-[70vh]"
                    src={attachment?.url}>
                    </iframe> : ''}
                    {!attachment?.url || attachment?.url == '' ? <p>Document not found.</p> : ''}
                </div>
            }
        </>
    )
}